import Vue from 'vue'
import PopUpApi from '../apis/pop_up'
export const state = () => ({
  token: "",
  url: "",
  name: "",
  id: "",
});
export const actions = {
  async copy({ commit, state }) {
    return await PopUpApi.copy(state)
  },
}
export const mutations = {
  setToken(state, token){
    state.token = token
  },
  setUrl(state, url){
    state.url = url
  },
  setName(state, name){
    state.name = name
  },
  setId(state, id){
    state.id = id
  }
}
export const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
